import { render } from "./CxServices.vue?vue&type=template&id=50a0d71a&scoped=true"
import script from "./CxServices.vue?vue&type=script&lang=js"
export * from "./CxServices.vue?vue&type=script&lang=js"

import "./CxServices.vue?vue&type=style&index=0&id=50a0d71a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a0d71a"]])

export default __exports__